@keyframes notfound-anim {

  0% {
    transform: rotate(10deg)
  }

  50% {
    transform: rotate(-10deg)
  }

  100% {
    transform: rotate(10deg)
  }

}
.sticker-404 img:hover {
  animation: notfound-anim 0.2s ease infinite;
}

@keyframes spinny-anim {
  0% {
    transform: rotateY(0deg);
  }
  40% {
    transform: rotateY(0deg);
  }
  100% {
    transform: rotateY(3600deg);
  }
}

.message:has(.sticker-spinny) {
  animation: spinny-anim 4s ease infinite;
}
